@let structure = structure$ | async;
@let isPage404 = isPage404$ | async;
@let showPoweredBy = showPoweredBy$ | async;
@let isEntityDragging = isEntityDragging$ | async;

<div cdkDropListGroup>
    @if (structure.length === 0) {
        <button class="btn btn-create btn-lg" (click)="addBlock()">
            <span class="sp-icon icon-plus"> </span>
            {{ "control_add_block" | translate }}
        </button>
    }

    <div [class.dragging-state]="isEntityDragging">
        @for (block of structure; track block.id; let index = $index; let first = $first; let last = $last) {
            @if (isZeroBlock(block)) {
                <web-zero-block [entity]="block" [index]="index" [isFirst]="first" [isLast]="last" />
            } @else if (isPlainBlock(block)) {
                <web-block
                    [entity]="block"
                    [previousSibling]="structure[index - 1] ?? null"
                    [nextSibling]="structure[index + 1] ?? null"
                    [index]="index"
                    [isFirst]="first"
                    [isLast]="last"
                />
            } @else if (isSharedBlock(block) && !isPage404) {
                <web-shared-block
                    [entity]="block"
                    [previousSibling]="structure[index - 1] ?? null"
                    [nextSibling]="structure[index + 1] ?? null"
                    [index]="index"
                    [isFirst]="first"
                    [isLast]="last"
                />
            } @else if (isSpecificBlock(block) && !isPage404) {
                <web-specific-block
                    [entity]="block"
                    [previousSibling]="structure[index - 1] ?? null"
                    [nextSibling]="structure[index + 1] ?? null"
                    [index]="index"
                    [isFirst]="first"
                    [isLast]="last"
                />
            }
        }
    </div>

    @if (structure.length && showPoweredBy) {
        <div class="powered-by-block new-banner">
            <div class="powered-sendpulse">
                <img src="./assets/img/websites/sendpulse-logo-symbol.svg" alt="SendPulse logo" />
                <span>{{ "footer_logo_powered_by" | translate }}</span>
            </div>
        </div>
    }
</div>

@let selectedEntity = selectedEntity$ | async;

@if (selectedEntity?.showSettings) {
    <web-settings-panel
        spPanelDrag
        spPanelDragTarget=".settings-panel"
        draggingBoundary=".panel-options-boundary"
        [panelPosition]="panelPosition()"
        [selectedEntity]="selectedEntity"
        (panelPositionChange)="savePanelPosition($event)"
    />
}
